// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Beachfront from '../_raw/ui/icon_beachfront.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Beachfront);
